<template>
	<div>
		<v-row>
			<v-col lg="4" mb="4" sm="12">
				<v-list color="transparent">
					<v-list-item-group
						v-model="selectedMenu"
						color="grey darken-2">
						<v-list-item>
							<v-list-item-icon class="mr-6">
								<svg class="blue--text" viewBox="0 0 28 28" width="28" height="28"><use xlink:href="#name_tag_outline_28"></use></svg>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title>Общие данные</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<!-- <v-list-item>
							<v-list-item-icon class="mr-6">
								<svg class="blue--text" viewBox="0 0 28 28" width="28" height="28"><use xlink:href="#name_tag_outline_28"></use></svg>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title>Персональные данные</v-list-item-title>
							</v-list-item-content>
						</v-list-item> -->
						<v-list-item>
							<v-list-item-icon class="mr-6">
								<svg class="blue--text" viewBox="0 0 28 28" width="28" height="28"><use xlink:href="#check_shield_outline_28"></use></svg>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title>Безопасность и вход</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<!-- <v-list-item>
							<v-list-item-icon class="mr-6">
								<svg class="blue--text" viewBox="0 0 28 28" width="28" height="28"><use xlink:href="#services_outline_28"></use></svg>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title>Сервисы и сайты</v-list-item-title>
							</v-list-item-content>
						</v-list-item> -->
					</v-list-item-group>
				</v-list>
				<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="position: absolute; width: 0; height: 0" aria-hidden="true" id="__SVG_SPRITE_NODE__"><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="spinner_24"><path d="M12 24a1.25 1.25 0 110-2.5A9.5 9.5 0 102.5 12c0 1.1.187 2.175.548 3.188a1.25 1.25 0 01-2.355.84A11.981 11.981 0 010 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12z" fill="currentColor" fill-rule="nonzero"></path></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" id="name_tag_outline_28"><g fill-rule="nonzero" fill="none"><path opacity=".527" d="M0 0h28v28H0z"></path><path d="M10.41 5c1.333 0 1.333 2 0 2l-.558.005c-1.479.028-2.141.18-2.823.545-.64.342-1.137.839-1.48 1.48-.364.68-.516 1.343-.544 2.822L5 12.41v5.18c0 1.881.142 2.62.55 3.38.342.641.839 1.138 1.48 1.48.68.365 1.343.517 2.822.545l.558.005h7.18c1.881 0 2.62-.142 3.38-.55a3.543 3.543 0 001.48-1.48c.365-.68.517-1.343.545-2.822L23 17.59v-5.18l-.005-.558c-.028-1.479-.18-2.141-.545-2.823a3.543 3.543 0 00-1.48-1.48c-.68-.364-1.343-.516-2.822-.544L17.59 7l-.133-.007c-1.156-.124-1.156-1.862 0-1.986L17.59 5H18l.071.003.172.004c1.649.038 2.581.232 3.499.69l.172.089a5.543 5.543 0 012.3 2.3c.553 1.034.764 2.03.784 3.988l.002.336v5.18c0 2.183-.203 3.233-.786 4.324a5.543 5.543 0 01-2.3 2.3c-1.034.553-2.03.764-3.988.784L10.41 25c-2.183 0-3.233-.203-4.324-.786a5.543 5.543 0 01-2.3-2.3c-.553-1.034-.764-2.03-.784-3.988L3 12.41c0-2.183.203-3.233.786-4.324a5.543 5.543 0 012.3-2.3c.976-.522 1.92-.74 3.67-.78l.172-.003L10 5h.41zM15 17a1 1 0 010 2H9a1 1 0 010-2h6zm4-5a1 1 0 010 2H9a1 1 0 010-2h10zm-5-9a1 1 0 011 1v4a1 1 0 01-2 0V4a1 1 0 011-1z" fill="currentColor"></path></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28" id="check_shield_outline_28"><g fill="currentColor"><path d="M13.484 1.502c.35-.05.682-.05 1.032 0 .345.05.633.127 1.296.348l6.82 2.273A2 2 0 0124 6.021V15.3c0 4.794-2.878 8.467-8.458 10.942l-.368.16a3 3 0 01-2.348 0C7.007 23.93 4 20.202 4 15.3V6.02a2 2 0 011.368-1.897l7.008-2.335c.533-.174.797-.242 1.108-.286zm.75 1.98a1.58 1.58 0 00-.468 0c-.2.029-.388.08-.946.265L6 6.021V15.3c0 4.016 2.471 7.078 7.609 9.262.25.106.532.106.775.003l.354-.154C19.641 22.236 22 19.226 22 15.3V6.02l-6.977-2.324a5.976 5.976 0 00-.668-.193z"></path><path d="M19.057 10.693a1 1 0 00-1.414 0l-4.893 4.893-1.893-1.893a1 1 0 00-1.414 1.414l2.6 2.6a1 1 0 001.414 0l5.6-5.6a1 1 0 000-1.414z"></path></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" id="money_circle_outline_28"><g fill="none" fill-rule="evenodd"><path d="M0 0h28v28H0z"></path><path d="M14 2c6.627 0 12 5.373 12 12s-5.373 12-12 12S2 20.627 2 14 7.373 2 14 2zm0 2C8.477 4 4 8.477 4 14s4.477 10 10 10 10-4.477 10-10S19.523 4 14 4zm1.673 4.5a3.662 3.662 0 110 7.325l-2.458-.001v1.403h1.637a.818.818 0 010 1.637l-1.637-.001v.78a.857.857 0 01-.857.857h-.14a.857.857 0 01-.857-.857l-.001-.78h-.872a.818.818 0 010-1.636h.872v-1.403h-.833a.857.857 0 01-.857-.856v-.156c0-.474.384-.857.857-.857l.833-.001V9.357c0-.473.385-.857.858-.857h3.455zm.036 1.714h-2.494v3.74h2.494a1.87 1.87 0 000-3.74z" fill="currentColor" fill-rule="nonzero"></path></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" id="history_forward_outline_28"><g fill="none" fill-rule="evenodd"><path d="M0 0h28v28H0z"></path><path d="M14.5 2c3.25 0 6.283 1.303 8.5 3.529V4l.007-.117A1 1 0 0125 4v4l-.007.117A1 1 0 0124 9h-4l-.117-.007A1 1 0 0120 7h1.643A9.974 9.974 0 0014.5 4c-5.523 0-10 4.477-10 10s4.477 10 10 10a9.964 9.964 0 007.072-2.93 1 1 0 111.415 1.414A11.963 11.963 0 0114.5 26c-6.627 0-12-5.373-12-12s5.373-12 12-12zM14 8a1 1 0 011 1v4.586l2.707 2.707a1 1 0 01-1.414 1.414l-3-3A1 1 0 0113 14V9a1 1 0 011-1z" fill="currentColor" fill-rule="nonzero"></path></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" id="services_outline_28"><g fill="none" fill-rule="evenodd"><path d="M0 0h28v28H0z"></path><path d="M9.116 15c1.065 0 1.623.108 2.205.419.54.289.971.72 1.26 1.26.311.582.419 1.14.419 2.205v2.232c0 1.065-.108 1.623-.419 2.205-.289.54-.72.971-1.26 1.26-.582.311-1.14.419-2.205.419H6.884c-1.065 0-1.623-.108-2.205-.419-.54-.289-.971-.72-1.26-1.26C3.108 22.739 3 22.18 3 21.116v-2.232c0-1.065.108-1.623.419-2.205.289-.54.72-.971 1.26-1.26.582-.311 1.14-.419 2.205-.419h2.232zm12 0c1.065 0 1.623.108 2.205.419.54.289.971.72 1.26 1.26.311.582.419 1.14.419 2.205v2.232c0 1.065-.108 1.623-.419 2.205-.289.54-.72.971-1.26 1.26-.582.311-1.14.419-2.205.419h-2.232c-1.065 0-1.623-.108-2.205-.419-.54-.289-.971-.72-1.26-1.26-.311-.582-.419-1.14-.419-2.205v-2.232c0-1.065.108-1.623.419-2.205.289-.54.72-.971 1.26-1.26.582-.311 1.14-.419 2.205-.419h2.232zm-12 2H6.884c-.763 0-1.01.048-1.261.182a1.045 1.045 0 00-.44.44c-.135.253-.183.499-.183 1.262v2.232c0 .763.048 1.01.182 1.261.103.193.248.338.44.44.253.135.499.183 1.262.183h2.232c.763 0 1.01-.048 1.261-.182.193-.103.338-.248.44-.44.135-.253.183-.499.183-1.262v-2.232c0-.763-.048-1.01-.182-1.261a1.045 1.045 0 00-.44-.44c-.253-.135-.499-.183-1.262-.183zm12 0h-2.232c-.763 0-1.01.048-1.261.182a1.045 1.045 0 00-.44.44c-.135.253-.183.499-.183 1.262v2.232c0 .763.048 1.01.182 1.261.103.193.248.338.44.44.253.135.499.183 1.262.183h2.232c.763 0 1.01-.048 1.261-.182.193-.103.338-.248.44-.44.135-.253.183-.499.183-1.262v-2.232c0-.763-.048-1.01-.182-1.261a1.045 1.045 0 00-.44-.44c-.253-.135-.499-.183-1.262-.183zM20.89 2.413c.631.19 1.102.51 1.856 1.263l1.577 1.577c.754.754 1.072 1.225 1.263 1.856a3.044 3.044 0 010 1.782c-.19.631-.51 1.102-1.263 1.856l-1.577 1.577c-.754.754-1.225 1.072-1.856 1.263a3.044 3.044 0 01-1.782 0c-.631-.19-1.102-.51-1.856-1.263l-1.577-1.577c-.754-.754-1.072-1.225-1.263-1.856a3.044 3.044 0 010-1.782c.19-.631.51-1.102 1.263-1.856l1.577-1.577c.754-.754 1.225-1.072 1.856-1.263a3.044 3.044 0 011.782 0zM9.116 3c1.065 0 1.623.108 2.205.419.54.289.971.72 1.26 1.26.311.582.419 1.14.419 2.205v2.232c0 1.065-.108 1.623-.419 2.205-.289.54-.72.971-1.26 1.26-.582.311-1.14.419-2.205.419H6.884c-1.065 0-1.623-.108-2.205-.419-.54-.289-.971-.72-1.26-1.26C3.108 10.739 3 10.18 3 9.116V6.884c0-1.065.108-1.623.419-2.205.289-.54.72-.971 1.26-1.26C5.261 3.108 5.82 3 6.884 3h2.232zm10.573 1.327c-.274.082-.482.223-1.021.763L17.09 6.668c-.54.54-.68.747-.763 1.02a1.045 1.045 0 000 .623c.082.274.223.482.763 1.021l1.578 1.578c.54.54.747.68 1.02.763.21.064.415.064.623 0 .274-.082.482-.223 1.021-.763l1.578-1.578c.54-.54.68-.747.763-1.02a1.045 1.045 0 000-.623c-.082-.274-.223-.482-.763-1.021L21.332 5.09c-.54-.54-.747-.68-1.02-.763a1.045 1.045 0 00-.623 0zM9.116 5H6.884c-.763 0-1.01.048-1.261.182a1.045 1.045 0 00-.44.44C5.047 5.876 5 6.122 5 6.885v2.232c0 .763.048 1.01.182 1.261.103.193.248.338.44.44.253.135.499.183 1.262.183h2.232c.763 0 1.01-.048 1.261-.182.193-.103.338-.248.44-.44.135-.253.183-.499.183-1.262V6.884c0-.763-.048-1.01-.182-1.261a1.045 1.045 0 00-.44-.44C10.124 5.047 9.878 5 9.115 5z" fill="currentColor" fill-rule="nonzero"></path></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" id="camera_outline_28"><g fill="none" fill-rule="evenodd"><path d="M0 0h28v28H0z"></path><path d="M15.697 2c.52 0 .993.065 1.43.202.458.143.87.364 1.244.665.356.288.673.645.961 1.078l.266.398.134.189c.097.13.162.197.235.258a.767.767 0 00.28.15c.129.038.259.056.578.06h.218c1.192.052 1.871.216 2.587.599A4.271 4.271 0 0125.4 7.37c.445.831.599 1.631.599 3.245v5.975c0 2.183-.203 3.233-.786 4.324a5.543 5.543 0 01-2.3 2.3c-1.091.583-2.14.786-4.324.786H9.41c-2.183 0-3.233-.203-4.324-.786a5.543 5.543 0 01-2.3-2.3c-.553-1.034-.764-2.03-.784-3.988v-6.604c.018-1.421.18-2.172.597-2.952A4.271 4.271 0 014.37 5.6c.691-.37 1.347-.534 2.451-.583l.089-.012L7 5h.175c.32-.004.45-.022.577-.06a.767.767 0 00.28-.15c.104-.085.19-.184.37-.447l.266-.398c.288-.433.605-.79.961-1.078a3.74 3.74 0 011.244-.665c.437-.137.91-.202 1.43-.202h3.394zm0 2h-3.394c-.327 0-.6.037-.832.11a1.74 1.74 0 00-.586.313c-.19.154-.372.36-.553.632l-.304.452c-.27.392-.465.613-.72.824a2.766 2.766 0 01-.98.524c-.34.102-.65.14-1.187.145l-.054.006-.27.012c-.752.039-1.109.133-1.504.345-.412.22-.73.538-.95.95-.269.502-.363.99-.363 2.302v5.975c0 1.881.142 2.62.55 3.38.342.641.839 1.138 1.48 1.48.68.365 1.343.517 2.822.545L9.41 22h9.18l.558-.005c1.479-.028 2.141-.18 2.823-.545a3.543 3.543 0 001.48-1.48c.364-.68.516-1.343.544-2.822L24 16.59v-5.975l-.005-.455c-.021-.98-.123-1.407-.358-1.847a2.271 2.271 0 00-.95-.95c-.431-.23-.82-.325-1.687-.363l-.242-.002c-.476-.008-.769-.047-1.086-.143a2.766 2.766 0 01-.98-.524c-.255-.21-.45-.432-.72-.824l-.304-.452a2.777 2.777 0 00-.553-.632 1.74 1.74 0 00-.586-.313 2.777 2.777 0 00-.832-.11zM14 8.5A5.25 5.25 0 1114 19a5.25 5.25 0 010-10.5zm0 2a3.25 3.25 0 100 6.5 3.25 3.25 0 000-6.5z" fill="currentColor" fill-rule="nonzero"></path></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16" id="dropdown_20"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.22 5.875a1 1 0 011.405-.156L10 9.22l4.375-3.5a1 1 0 011.25 1.562l-5 4a1 1 0 01-1.25 0l-5-4a1 1 0 01-.156-1.406z" fill="currentColor"></path></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" id="phone_outline_20"><g fill="none" fill-rule="evenodd"><path opacity=".1" d="M0 0h20v20H0z"></path><path d="M7.78 2.7l.7.833c1.373 1.628 1.229 4.054-.299 5.582l-.297.296c.226.38.633.878 1.23 1.475.53.53.984.912 1.344 1.149l.13.082.298-.297c1.526-1.527 3.95-1.672 5.58-.302l.833.702c1.46 1.229 1.602 3.419.346 4.894a3.859 3.859 0 01-2.29 1.289l-.506.06c-3.005.292-6.037-1.16-9.094-4.217-3.056-3.056-4.51-6.09-4.226-9.025l.06-.515a3.834 3.834 0 011.3-2.354l.168-.135c1.462-1.107 3.54-.924 4.723.484zm-3.911.788c-.321.276-.562.633-.698 1.033a2.37 2.37 0 00-.115.552c-.343 2.548.898 5.25 3.76 8.112 2.86 2.862 5.562 4.103 8.123 3.758a2.376 2.376 0 001.571-.81c.719-.844.636-2.082-.177-2.766l-.833-.701-.142-.112c-1.02-.739-2.471-.614-3.411.326l-.597.598-.088.076a.903.903 0 01-.862.133c-.648-.238-1.425-.818-2.346-1.74-.923-.923-1.503-1.7-1.74-2.347a.903.903 0 01.209-.95l.598-.597.129-.137c.862-.987.906-2.44.084-3.416l-.702-.834-.112-.122c-.7-.697-1.853-.735-2.651-.056z" fill="currentColor" fill-rule="nonzero"></path></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" id="mail_outline_28"><g fill="none" fill-rule="evenodd"><path opacity=".1" d="M0 0h28v28H0z"></path><path d="M8.128 4l12.049.002c1.574.019 2.396.195 3.248.65a4.634 4.634 0 011.923 1.923c.484.905.652 1.776.652 3.553v7.744c0 1.777-.168 2.648-.652 3.553a4.634 4.634 0 01-1.923 1.923c-.905.484-1.776.652-3.553.652H8.128c-1.777 0-2.648-.168-3.553-.652a4.634 4.634 0 01-1.923-1.923C2.168 20.52 2 19.65 2 17.872l.002-8.049c.019-1.574.195-2.396.65-3.248a4.634 4.634 0 011.923-1.923C5.48 4.168 6.35 4 8.128 4zm15.56 3.728l-6.86 6.858a4 4 0 01-5.497.15l-.16-.15-6.858-6.858c-.23.515-.313 1.104-.313 2.4v7.744c0 1.475.108 2.034.416 2.61.255.478.624.847 1.102 1.102.508.272 1.003.388 2.126.411l.484.005h11.744c1.475 0 2.034-.108 2.61-.416a2.635 2.635 0 001.102-1.102c.272-.508.388-1.003.411-2.126l.005-.484v-7.744c0-1.296-.083-1.885-.313-2.4zM19.871 6H8.128c-1.296 0-1.885.083-2.4.313l6.858 6.859a2 2 0 002.701.116l.127-.116 6.858-6.86c-.515-.229-1.104-.312-2.4-.312z" fill="currentColor" fill-rule="nonzero"></path></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 16" id="more_vertical_16"><g fill="none" fill-rule="evenodd"><path d="M0 0h8v16H0z"></path><path d="M4 4.5c.825 0 1.5-.675 1.5-1.5S4.825 1.5 4 1.5 2.5 2.175 2.5 3 3.175 4.5 4 4.5zm0 2c-.825 0-1.5.675-1.5 1.5S3.175 9.5 4 9.5 5.5 8.825 5.5 8 4.825 6.5 4 6.5zm0 5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5z" fill="currentColor"></path></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" id="key_outline_28"><g fill="none" fill-rule="evenodd"><path d="M0 0h28v28H0z"></path><path d="M25 2a1 1 0 011 1v4a1 1 0 01-1 1h-2v2a1 1 0 01-.883.993L22 11h-2v2a1 1 0 01-.883.993L19 14h-2.556l.18.3c.58 1.02.917 2.17.969 3.371L17.6 18a7.5 7.5 0 11-5.78-7.301l.054.013 8.419-8.42a1 1 0 01.576-.283L21 2zm-1 2h-2.586l-8.541 8.542a1 1 0 01-.904.274l-.12-.033a5.5 5.5 0 102.504 1.728 1 1 0 01.064-1.341l.876-.877A1 1 0 0116 12h2v-2a1 1 0 01.883-.993L19 9h2V7a1 1 0 01.883-.993L22 6h2V4zM8.5 18.2a1.3 1.3 0 110 2.6 1.3 1.3 0 010-2.6z" fill="currentColor" fill-rule="nonzero"></path></g></symbol><symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" id="delete_outline_android_28"><g fill="none" fill-rule="evenodd"><path d="M0 0h28v28H0z"></path><path d="M22 10v10.5a4.5 4.5 0 01-4.5 4.5h-7A4.5 4.5 0 016 20.5V10h-.71A1.29 1.29 0 014 8.71V7.25A2.75 2.75 0 016.75 4.5h1.651A3.001 3.001 0 0111 3h6c1.097 0 2.075.593 2.599 1.5h1.651A2.75 2.75 0 0124 7.25v1.46A1.29 1.29 0 0122.71 10H22zm-1-2h1v-.75a.75.75 0 00-.75-.75h-2.313a1 1 0 01-.968-.75A1 1 0 0017 5h-6a1 1 0 00-.969.75 1 1 0 01-.968.75H6.75a.75.75 0 00-.75.75V8h15zM8 10v10.5a2.5 2.5 0 002.5 2.5h7a2.5 2.5 0 002.5-2.5V10H8z" fill="currentColor" fill-rule="nonzero"></path></g></symbol></svg>
			</v-col>
			<v-col lg="8" mb="8" sm="12" v-if="Object.keys(profileData).length != 0">
				<v-card outlined v-if="selectedMenu === 0">
					<v-card-text>
						<v-form ref="mainInfoForm">
							<v-row class="mx-0">
								<v-col lg="6">
									<v-text-field
										v-model="profileData.body['iin']"
										:label="profileData.header.iin.label"
										type="number"
										:rules="[v => true || !!v || 'Обязательное поле', v => !v || v.match(/\d/g).length === 12 || 'Неправильный формат ИИН']">
									</v-text-field>
								</v-col>
								<v-col lg="6">
									<v-text-field
										v-model="profileData.body['nickname']"
										:label="profileData.header.nickname.label"
										:type="profileData.header.nickname.type"
										:rules="[v => true || !!v || 'Обязательное поле']">
									</v-text-field>
								</v-col>
							</v-row>
						</v-form>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="primary" text @click.stop="submitChange" :loading="isLoading">
							Сохранить
						</v-btn>
					</v-card-actions>
				</v-card>
				<template v-if="selectedMenu === 1">
					<v-card class="mb-6" v-if="Object.keys(profileData).length != 0" outlined>
						<v-card-text>
							<v-list>
								<v-list-item class="mb-5">
									<v-list-item-icon>
										<v-icon>mdi-phone</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-subtitle class="mb-2">{{ profileData.header.phone.label }}</v-list-item-subtitle>
										<v-list-item-title class="text-lg-h6">{{ profileData.body['header'] }}</v-list-item-title>
										<v-list-item-subtitle class="mt-2">Телефон для восстановления доступа.</v-list-item-subtitle>
									</v-list-item-content>

									<v-list-item-icon>
										<v-icon @click="changeEmailOrPhoneNumber('phone')">mdi-pencil</v-icon>
									</v-list-item-icon>
								</v-list-item>
								<v-list-item class="mb-5">
									<v-list-item-icon>
										<v-icon>mdi-email</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-subtitle class="mb-2">{{ profileData.header.email.label }}</v-list-item-subtitle>
										<v-list-item-title class="text-lg-h6">{{ profileData.body['email'] }}</v-list-item-title>
										<v-list-item-subtitle class="mt-2">Почта для восстановления доступа.</v-list-item-subtitle>
									</v-list-item-content>

									<v-list-item-icon>
										<v-icon @click="changeEmailOrPhoneNumber('email')">mdi-pencil</v-icon>
									</v-list-item-icon>
								</v-list-item>
								<v-list-item class="mb-5">
									<v-list-item-content>
										<v-btn color="primary" text @click="changePasswordDialog = true"><v-icon class="mr-3">mdi-key</v-icon> Изменить пароль</v-btn>
										<!-- <v-list-item-subtitle class="mb-2">{{ profileData.header.email.label }}</v-list-item-subtitle>
										<v-list-item-title class="text-lg-h6">{{ profileData.body['email'] }}</v-list-item-title>
										<v-list-item-subtitle class="mt-2">Почта для восстановления доступа.</v-list-item-subtitle> -->
									</v-list-item-content>
								</v-list-item>
							</v-list>
						</v-card-text>
					</v-card>
				</template>
			</v-col>
		</v-row>

		<v-dialog v-model="confirmEmailOrPhoneNumberDialog" width="500" v-if="currentEmailOrPhoneNumberItemName">
			<v-card>
				<v-card-title class="headline lighten-2">Изменить</v-card-title>

				<v-card-text>
					<v-form class="form" ref="changeEmailOrPhoneNumberForm" @submit.prevent="resend ? changeEmailOrPhoneNumberCodeSubmit() : changeEmailOrPhoneNumberSubmit()">
						<template v-if="!resend">
							<v-text-field
								v-if="currentEmailOrPhoneNumberItemName == 'email'"
								v-model="currentEmailOrPhoneNumberItem.value"
								:label="profileData.header[currentEmailOrPhoneNumberItemName].label"
								type="text"
								:rules="[v => !!v || 'Обязательное поле', v => /.+@.+\..+/.test(v) || 'Введите корректный E-mail']">
							</v-text-field>
							<v-text-field
								v-else
								v-model="currentEmailOrPhoneNumberItem.value"
								:label="profileData.header[currentEmailOrPhoneNumberItemName].label"
								type="number"
								:rules="[v => !!v || 'Обязательное поле', v => v.match(/\d/g).length === 12 || 'Введите корректный номер телефона']">
							</v-text-field>
							
							<v-text-field
								label="Пароль"
								type="password"
								prepend-icon="mdi-key"
								v-model="currentEmailOrPhoneNumberItem.password"
								:rules="[v => !!v || 'Обязательное поле']"
							></v-text-field>
						</template>
						<template v-else>
							Вам на {{ currentEmailOrPhoneNumberItemName == 'email' ? 'почту' : 'номер' }} {{ currentEmailOrPhoneNumberItem.value }} отправлен код.
							
							<v-text-field
								color="indigo lighten-1"
								label="Введите код"
								type="text"
								v-model="currentEmailOrPhoneNumberItem.code"
								:rules="[v => !!v || 'Обязательное поле']"
								required
							></v-text-field>
							<template v-if="currentEmailOrPhoneNumberItem.duration">
								Вы можете повторно запросить код через {{currentEmailOrPhoneNumberItem.duration}} секунд.
							</template> 
							<v-btn v-else small text @click="resendCodeRequest(currentEmailOrPhoneNumberItem, setConfirmCountDown)" :disabled="isLoading">
								Запросить код повторно
							</v-btn>
						</template>
					</v-form>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="resend ? changeEmailOrPhoneNumberCodeSubmit() : changeEmailOrPhoneNumberSubmit()" :loading="isLoading">
						Отправить
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="changePasswordDialog" width="500">
			<v-card>
				<v-card-title class="headline lighten-2">Изменить пароль</v-card-title>

				<v-card-text>
					<v-form class="form" ref="changePasswordForm" @submit.prevent="changePasswordSubmit()">
						<v-text-field
							label="Введите пароль"
							type="password"
							prepend-icon="mdi-key"
							v-model="changePasswordData.password"
							:rules="[v => !!v || 'Обязательное поле']"
						></v-text-field>
						<v-text-field
							label="Введите новый пароль"
							type="password"
							v-model="changePasswordData.new_password"
							:rules="[v => !!v || 'Обязательное поле']"
						></v-text-field>
						<v-text-field
							label="Повторите новый пароль"
							type="password"
							v-model="changePasswordData.new_password2"
							:rules="[v => !!v || 'Обязательное поле', v => v == changePasswordData.new_password || 'Пароли не совпадают']"
						></v-text-field>
					</v-form>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="changePasswordSubmit()" :loading="isLoading">
						Отправить
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	export default {
		mounted() {
			this.getProfileData();

		},
		data: () => ({
			isLoading: false,
			resend: false,
			profileData: {},
			intervalId: null,
			confirmEmailOrPhoneNumberDialog: false,
			currentEmailOrPhoneNumberItemName: null,
			currentEmailOrPhoneNumberItem: {
				'value': null,
				'code': null,
				'duration': null,
				'password': null,
				'key': null
			},
			selectedMenu: 0,
			changePasswordDialog: false,
			changePasswordData: {},
		}),
		methods: {
			async getProfileData() {
				this.profileData = {};
				await this.$http.get('/public/api/ru/v1/main').then((response) => {
					this.isLoading = false;
					this.profileData = response.data.data;
				}).catch(() => this.isLoading = false);
			},
			async submitChange() {
				let sendData = {
					'iin': this.profileData.body.iin,
					'nickname': this.profileData.body.nickname,
				};

				if(this.$refs.mainInfoForm.validate()) {
					this.isLoading = true;
					await this.$http.post('/public/api/ru/v1/main/update/info', sendData).then((response) => {
						this.$store.dispatch('alertAdd', {text: response.data.message, type: 'success'});
					}).catch(() => this.isLoading = false);
					this.isLoading = false;
				}
			},
			changeEmailOrPhoneNumber(item) {
				this.currentEmailOrPhoneNumberItemName = item;
				this.confirmEmailOrPhoneNumberDialog = true;
			},
			async changeEmailOrPhoneNumberSubmit() {
				if(this.$refs.changeEmailOrPhoneNumberForm.validate() || this.resend) {
					this.isLoading = true;
					let sendData = {};
					sendData[this.currentEmailOrPhoneNumberItemName] = this.currentEmailOrPhoneNumberItemName == 'email' ? this.currentEmailOrPhoneNumberItem.value : '+'+this.currentEmailOrPhoneNumberItem.value;
					sendData['password'] = this.currentEmailOrPhoneNumberItem.password;

					await this.$http.post('/public/api/ru/v1/main/update/auth-info', sendData).then((response) => {
						this.isLoading = false;
						this.resend = true;
						this.currentEmailOrPhoneNumberItem['duration'] = response.data.data.duration;
						this.currentEmailOrPhoneNumberItem['key'] = response.data.data.key;
						this.setConfirmCountDown(this.currentEmailOrPhoneNumberItem);
					}).catch(() => this.isLoading = false);
				}
			},
			async changeEmailOrPhoneNumberCodeSubmit() {
				if(this.$refs.changeEmailOrPhoneNumberForm.validate()) {
					this.isLoading = true;
					let sendData = {
						'code': this.currentEmailOrPhoneNumberItem.code,
						'key': this.currentEmailOrPhoneNumberItem.key,
					};
					
					await this.$http.post('/public/api/ru/v1/main/update/auth-verify', sendData).then(() => {
						this.isLoading = false;

						this.confirmEmailOrPhoneNumberDialog = false;
						this.resend = false;
						this.getProfileData();
					}).catch(() => this.isLoading = false);
				}
			},
			async resendCodeRequest(data, callback) { // TODO
				this.isLoading = true;
				await this.$http.post('/public/api/ru/v1/auth/resend', {
					"key" : data.key
				}).then((response) => {
					this.isLoading = false;
					data.duration = response.data.data.duration;
					data.key = response.data.data.key;
					this.$store.dispatch('alertAdd', {text: response.data.message, type: 'success'});
					callback(data);
				}).catch(() => this.isLoading = false);
			},
			setConfirmCountDown(obj) {
				this.intervalId = setInterval(() => {
					if(obj.duration === 0) {
						this.clearCountDown();
					} else {
						obj.duration--;
					}
				}, 1000);
			},
			clearCountDown() {
				clearInterval(this.intervalId);
			},
			async changePasswordSubmit() {
				if(this.$refs.changePasswordForm.validate()) {
					this.isLoading = true;
					await this.$http.post('/public/api/ru/v1/main/update/password', this.changePasswordData).then((response) => {
						this.isLoading = false;
						this.$store.dispatch('alertAdd', {text: response.data.message, type: 'success'});
						this.changePasswordDialog = false;
					}).catch(() => this.isLoading = false);
				}
			},
			async toBase64(file) {
				return new Promise((resolve) => {
					const reader = new FileReader();
					reader.readAsDataURL(file);
					reader.onload = () => {
						let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
						if ((encoded.length % 4) > 0) {
							encoded += '='.repeat(4 - (encoded.length % 4));
						}
						resolve(encoded);
					};
				});
			},
			isValidHttpUrl(string) {
				let url;

				try {
					url = new URL(string);
				} catch (_) {
					return false;  
				}

				return url.protocol === "http:" || url.protocol === "https:";
			}
		},
		watch: {
			confirmEmailOrPhoneNumberDialog: function (v) {
				if(!v) {
					this.$refs.changeEmailOrPhoneNumberForm.reset()

					this.resend = false;
					this.currentEmailOrPhoneNumberItemName = null;
				}
			},
			changePasswordDialog: function (v) {
				if(!v) {
					this.$refs.changePasswordForm.reset()
				}
			},
			// selectedMenu: function (v) {
			// 	if(v == 0 || v == 1 || v == 2) {
			// 		this.getProfileData();
			// 	}
			// },
		}
  }
</script>

<style scoped>
	.avatar {
		position: relative;
		cursor: pointer;
	}
	.avatar .v-icon {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		border: 0;
		color: #fff;
		background-color: rgba(0, 0, 0, 0.5);
		display: none;
	}
	.avatar:hover .v-icon {
		display: inline-flex;
	}
</style>